import { map } from 'rxjs';
import { SuperAdminService } from '../../services/super-admin/super-admin.service';
import { UserAccessApi } from '../../common-files/user-access-api';

// the super admin's view of a user's access: every role (central or branch), every
// establishment, every view-permission of the catalogue.
export function superAdminUserAccessApi(superAdminService: SuperAdminService): UserAccessApi {
  return {
    canManage: true,
    allowCentralAssignment: true,
    getAccess: (sumId) => superAdminService.getUserAccess(sumId),
    listAssignableRoles: () =>
      superAdminService
        .listRoles()
        .pipe(map((res: any) => (res?.data?.roles || []).filter((r: any) => Number(r.status) !== 0))),
    listEstablishments: () =>
      superAdminService.listEstablishments().pipe(map((res: any) => res?.data?.establishments || [])),
    assignRole: (sumId, payload) =>
      superAdminService.assignRole(sumId, {
        roleKey: payload.roleKey,
        establishmentId: payload.establishmentId,
        validUntil: payload.validUntil ?? null,
      }),
    setRoleStatus: (sumId, suremId, active) => superAdminService.setUserRoleStatus(sumId, suremId, active),
    listAssignablePermissions: () =>
      superAdminService.listViewPermissions().pipe(
        map((res: any) =>
          (res?.data?.viewPermissions || []).map((p: any) => ({
            ...p,
            roles: p.roles || p.applicableFor, // the picker shows this under the permission
          }))
        )
      ),
    grantPermission: (sumId, suremId, svpId) => superAdminService.grantUserPermission(sumId, suremId, svpId),
    setPermissionStatus: (sumId, supdId, active) => superAdminService.setUserPermissionStatus(sumId, supdId, active),
    setPermissionsStatus: (sumId, supdIds, active) =>
      superAdminService.setUserPermissionsStatus(sumId, supdIds, active),
  };
}
